export default "__VITE_ASSET__Cmb51EZ3__"